module.exports = __webpack_public_path__ + "img/hoslogo6.1a1b9025.png";